module.exports = __webpack_public_path__ + "static/img/1_0042.44ae728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0042.jpg
// module id = Q6s6
// module chunks = 0